import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/credit-index-scores')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/credit-index-scores']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
